
<template>
    <div style="margin-top: 67px; background-color: #fafafa;">
      <step isActiveCard="true"></step>
      <section class="desktop">
        <div class="card-wrapper">
          <table>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr class="card-company-input-wrapper">
              <td>카드사</td>
              <td colspan="5">
                <select style="width: 100%" v-model="cardCompany" id="year" title="" name="">
                  <option v-for="(company, index) in companies" :key="index" v-bind:value="company">{{company}}</option>
                </select>
              </td>
            </tr>
            <tr class="card-number-input-wrapper">
              <td colspan="2">카드 번호</td>
              <td><input type="text" v-model="firstCardNumber" maxlength="4"></td>
              <td><input type="text" v-model="secondCardNumber" maxlength="4"></td>
              <td><input type="text" v-model="thirdCardNumber" maxlength="4"></td>
              <td><input type="text" v-model="fourthCardNumber" maxlength="4"></td>
            </tr>
            <tr class="due-date-input-wrapper">
              <td colspan="2">유효 기간</td>
              <td colspan="2">
                <div style="position: relative">
                  <label class="label-in-input" v-bind:class="{hidden: isMonthPicked}" for="month">월</label>
                  <select v-model="dueDateMonth" id="mo[nth" title="" name="">
                    <option v-for="(month, index) in months" :key="index" v-bind:value="month">{{month}}</option>
                  </select>
                </div>
              </td>
              <td colspan="2">
                <div style="position: relative">
                  <label class="label-in-input" v-bind:class="{hidden: isYearPicked}" for="year">년</label>
                  <select v-model="dueDateYear" id="year" title="" name="">
                    <option v-for="(year, index) in years" :key="index" v-bind:value="year">{{year}}</option>
                  </select>
                </div>
              </td>
            </tr>
            <tr class="alert-encryption-wrapper">
              <td colspan="6">
                <img style="width: 13px;" src="@/assets/icon-lock.png" alt="">
                <span>모든 카드 정보는 암호화되어 안전하게 보관됩니다.</span>
              </td>
            </tr>
            <tr class="service-agreement-wrapper">
              <td colspan="6">
                <input type="checkbox" class="service-agreement-input" id="service-agreement" v-model="isAgreed">
                <label for="service-agreement" @click="toggleIsAgreed()" class="service-agreement-checkbox" v-bind:class="{active: isAgreed}"></label>
                <span>서비스 이용 약관과 개인정보 취급 정책에 동의합니다.</span>
              </td>
            </tr>
            <tr>
              <td colspan="6">
                <button style="cursor: pointer" @click="goComplete" v-bind:class="{hidden: isClicked}" class="completeApply">신청 완료하기</button>
              </td>
            </tr>
          </table>
        </div>
      </section>
      <section class="mobile">
        <div class="m-card-wrapper">
          <div class="m-card-company-input-wrapper">
            <label for="">카드사</label>
            <div class="m-card-input flex-container">
              <label class="label-in-input" v-bind:class="{hidden: isMonthPicked}" for="company">선택</label>
              <select style="width: 100%" v-model="cardCompany" id="company" title="" name="">
                <option v-for="(company, index) in companies" :key="index" v-bind:value="company">{{company}}</option>
              </select>
            </div>
          </div>
          <div class="m-card-number-input-wrapper">
            <label for="">카드 번호</label>
            <div class="m-card-input flex-container">
              <input type="text" v-model="firstCardNumber" maxlength="4">
              <input type="text" v-model="secondCardNumber" maxlength="4">
              <input type="text" v-model="thirdCardNumber" maxlength="4">
              <input type="text" v-model="fourthCardNumber" maxlength="4">
            </div>
          </div>
          <div class="m-due-date-input-wrapper">
            <label for="">유효기간</label>
            <div class="m-card-input flex-container">
              <div style="position: relative; width: 100%;">
                <label class="label-in-input" v-bind:class="{hidden: isMonthPicked}" for="month">월</label>
                <select style="width: 100%" v-model="dueDateMonth" id="month" title="" name="">
                  <option v-for="(month, index) in months" :key="index" v-bind:value="month">{{month}}</option>
                </select>
              </div>
              <div style="position: relative; width: 100%;">
                <label class="label-in-input" v-bind:class="{hidden: isYearPicked}" for="year">년</label>
                <select style="width: 100%" v-model="dueDateYear" id="year" title="" name="">
                  <option v-for="(year, index) in years" :key="index" v-bind:value="year">{{year}}</option>
                </select>
              </div>
            </div>
            <div class="m-alert-encryption-wrapper">
              <img style="width: 13px;" src="@/assets/icon-lock.png" alt="">
              <span>모든 카드 정보는 암호화되어 안전하게 보관됩니다.</span>
            </div>
          </div>
          <div class="m-service-agreement-wrapper">
            <input type="checkbox" class="service-agreement-input" id="service-agreement-input" v-model="isAgreed">
             <label for="service-agreement-input" @click="toggleIsAgreed()" class="service-agreement-checkbox" v-bind:class="{active: isAgreed}"></label>
             <span>서비스 이용 약관과 개인정보 취급 정책에 동의합니다.</span>
          </div>
          <div class="m-button-wrapper" style="margin-bottom: 50px;">
             <button @click="goComplete" v-bind:class="{hidden: isClicked}" class="completeApply">신청 완료하기</button>
          </div>
        </div>
      </section>
      <app-footer></app-footer>
    </div>
</template>

<script>
import Step from './Step'
import AppFooter from '../AppFooter'
import {convertProductNameFrom} from '../../modules/products'
import {PAYMENT_METHOD_BY_NUM, convertPaymentMethodInStrBy} from '../../modules/payment_methods'
const alertOptions = {title: '', size: 'sm', okLabel: '확인'}

export default {
  name: 'card',
  components: { Step, AppFooter },
  data () {
    return {
      dueDateMonth: '',
      dueDateYear: '',
      isMonthPicked: false,
      isYearPicked: false,
      isAgreed: false,
      isClicked: false,
      months: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      years: ['2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027',
        '2028', '2029', '2030', '2031', '2032', '2033', '2034', '2035', '2036', '2037', '2038', '2039',
        '2040', '2041'],
      firstCardNumber: '',
      secondCardNumber: '',
      thirdCardNumber: '',
      fourthCardNumber: '',
      cardCompany: '',
      companies: ['비씨', '국민', '하나(외환)', '삼성', '신한', '현대', '롯데', '씨티', 'NH채움', '수협', '신협', '우리카드', '카카오뱅크', '광주', '전북', '제주',
        '산은캐피탈', '해외 비자', '해외 마스터', '해외 다이너스', '해외 AMX', '해외 JCB', 'OKCashbag', '우체국', 'MG새마을 체크카드', '중국은행 체크카드',
        'KDB 체크카드', '현대증권 체크카드', '저축은행']
    }
  },
  computed: {
    cartItems () {
      return this.$store.state.cartItems
    },
    applicant () {
      return this.$store.state.applicant
    },
    applicantProducts () {
      return this.$store.state.applicantProducts
    },
    numberOfCartItems () {
      return this.$store.state.numberOfCartItems
    }
  },
  methods: {
    async goComplete () {
      this.isClicked = true
      if (this.numberOfCartItems === 0) {
        this.$dialogs.alert('장바구니에 담긴 제품이 없습니다 ! 제품을 먼저 골라주세요.', alertOptions)
        this.isClicked = false
        return
      }
      let eventInfo = await this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/events/advertising/')
      if (eventInfo.status === 204) {
        this.$dialogs.alert('무료체험이 매진되었습니다. 곧 다시 모집할테니 걱정마세요!', alertOptions)
        return
      }
      this.$store.commit({
        type: 'addApplicantInfo',
        key: 'eventId',
        value: eventInfo.data.id
      })
      let stockInfo = await this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/events/' + eventInfo.data.id + '/stocks/')
      for (var i = 0; i < this.cartItems.length; i++) {
        for (var j = 0; j < stockInfo.data.results.length; j++) {
          if (stockInfo.data.results[j].product_id === this.cartItems[i].id) {
            if (stockInfo.data.results[j].available_quantity === 0) {
              let name = convertProductNameFrom(this.cartItems[i].id)
              this.$dialogs.alert(name + '는 품절되었습니다.', alertOptions)
              return
            }
          }
        }
      }
      if (this.applicant.paymentMethod === PAYMENT_METHOD_BY_NUM.LEASE) {
        if (eventInfo.data.available_lease_quantity < this.cartItems.length) {
          this.$dialogs.alert('앗! 분할 결제 방식은 매진되었습니다. 일시불 방식으로 신청은 어떠세요?', alertOptions)
          return
        }
      }

      if (this.firstCardNumber === '' || this.secondCardNumber === '' || this.thirdCardNumber === '' ||
      this.fourthCardNumber === '' || this.dueDateMonth === '' || this.dueDateYear === '') {
        this.$dialogs.alert('정보를 모두 입력해주세요.', alertOptions)
        this.isClicked = false
      } else {
        if (this.isAgreed) {
          this.createCard()
        } else {
          this.$dialogs.alert('이용약관에 대한 동의가 필요합니다.', alertOptions)
          this.isClicked = false
        }
      }
    },
    async createCard () {
      let data = new FormData()
      data.append('customer', this.applicant.customerId)
      data.append('card_number', this.firstCardNumber + this.secondCardNumber + this.thirdCardNumber + this.fourthCardNumber)
      data.append('company_name', this.cardCompany)
      data.append('expiration_year', this.dueDateYear)
      data.append('expiration_month', this.dueDateMonth)
      await this.$http.post(process.env.URL_EVENT_SERVICE + '/v1/credit-cards/', data)
        .then((result) => {
          console.log(result)
          if (result.status === 201) {
            this.createFreeTrial()
          } else {
            this.$dialogs.alert('죄송합니다. 서버와의 통신에 실패하였습니다. 고객센터로 문의해주세요.', alertOptions)
          }
        })
        .catch((error) => {
          if (error.response.status === 500 || error.response.status === 504) {
            this.$dialogs.alert('죄송합니다. 현재 접속자가 많아 카드 정보를 등록하는데 실패했습니다. \n' +
            '새로고침 후에 다시 시도해주세요 !', alertOptions)
          } else if (error.response.status === 400 && error.response.data.code === 56) {
            this.$dialogs.alert('카드번호가 올바르지 않습니다.', alertOptions)
          } else if (error.response.status === 400 && error.response.data.code === 57) {
            this.createFreeTrial()
          } else {
            this.$dialogs.alert('죄송합니다. 서버와의 통신에 실패하였습니다. 고객센터로 문의해주세요.', alertOptions)
          }
        })
    },
    async createFreeTrial () {
      for (var i = 0; i < this.applicantProducts.length; i++) {
        let data = new FormData()
        data.append('event_id', this.applicant.eventId)
        data.append('product_id', this.applicantProducts[i])
        data.append('customer_id', this.applicant.customerId)
        data.append('payment_method', convertPaymentMethodInStrBy(this.applicant.paymentMethod))
        await this.$http.post(process.env.URL_EVENT_SERVICE + '/v1/free-trials/', data)
          .then((result) => {
            if (result.status === 201) {
              this.$router.push({ name: 'Complete' })
            } else {
              this.$dialogs.alert('죄송합니다. 서버와의 통신에 실패하였습니다. 고객센터로 문의해주세요.', alertOptions)
            }
          })
          .catch((error) => {
            console.log(error.response)
            if (error.response.status === 500 || error.response.status === 504) {
              this.$dialogs.alert('죄송합니다. 현재 접속자가 많아 카드 정보를 등록하는데 실패했습니다. \n' +
            '새로고침 후에 다시 시도해주세요 !', alertOptions)
            } else if (error.response.status === 406 && error.response.data.code === 31) {
              this.$dialogs.alert('죄송합니다. 이미 무료체험을 신청하셨습니다.', alertOptions)
            } else if (error.response.status === 406 && error.response.data.code === 30) {
              this.$dialogs.alert('죄송합니다. 쓰다가 구매하기가 매진되었습니다. 바로 구매하기로 신청해보시겠어요?', alertOptions)
            } else if (error.response.status === 400 && error.response.data.code === 26) {
              this.$dialogs.alert('죄송합니다. 제품이 매진되었습니다. 조금만 기다려주시면 다시 신청을 재개하겠습니다.', alertOptions)
            } else if (error.response.status === 400 && error.response.data.code === 12) {
              this.$dialogs.alert('죄송합니다. 무료체험이 마감되었습니다. 다음 무료체험 모집을 기다려주세요.', alertOptions)
            } else {
              this.$dialogs.alert('죄송합니다. 서버와의 통신에 실패하였습니다. 고객센터로 문의해주세요.', alertOptions)
            }
          })
      }
    },
    toggleIsAgreed: function () {
      this.isAgreed = !this.isAgreed
    }
  },
  watch: {
    dueDateMonth: function () {
      if (this.dueDateMonth !== '') {
        this.isMonthPicked = true
      }
    },
    dueDateYear: function () {
      if (this.dueYearMonth !== '') {
        this.isYearPicked = true
      }
    }
  }
}
</script>

<style scoped>

.card-wrapper {
  margin-top: 40px;
  display: inline-block;
}
.flex-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: url("../../assets/btn-dropdown.png") no-repeat 95% 50%;
  background-size: 12px;
  width:185px;
  height:47px;
  border-radius: 2px;
  background-color: #ffffff;
  border: solid 1px #eef0f1;
}

table {
  border-collapse: separate;
  border-spacing: 15px;
  margin-bottom: 100px;
}

input {
  border: solid 1px #eef0f1;
  border-radius: 2px;
  text-align: center;
  outline: 0;
}
.card-number-input-wrapper input {
  width: 88px;
  height: 47px;
}

.card-company-input-wrapper input {
  width: 200px;
  height: 47px;
}

.due-date-input-wrapper input {
  width: 185px;
  height: 47px;
}

/* .due-date-input-wrapper label {
  position: absolute;
  top: 10px;
  left: 20px;
} */

.label-in-input {
  position: absolute;
  top: 10px;
  left: 20px;
}
.alert-encryption-wrapper {
  font-size: 12px;
  border-bottom-width: 20px;
}

.alert-encryption-wrapper span {
  vertical-align: sub;
}

.service-agreement-wrapper td {
  padding: 20px;
  border-top: solid 1px #dee2e5;
  border-bottom: solid 1px #dee2e5;
  font-size: 14px;

}

.service-agreement-checkbox {
  width: 20px;
  height: 20px;
  background: url("../../assets/check-disable.png") center no-repeat;
  background-size: 20px;
  position: relative;
  top: 13px;
  right: 6px;
}
.service-agreement-checkbox.active {
  background: url("../../assets/check-active.png") center no-repeat;
  background-size: 20px;
}

.service-agreement-input {
  display: none;
}

.completeApply {
  width: 240px;
  height: 50px;
  border-radius: 2px;
  background-color: #6f97fa;
  color: #ffffff;
  font-size: 16px;
  letter-spacing: -0.5px;
  font-weight: bold;
  border: 0;
  outline: 0;
}

.completeApply:hover {
  background-color: #5686fe;
}
.hidden {
  display: none;
}
.m-card-wrapper {
  padding: 20px;
}

.m-card-number-input-wrapper {
  text-align: left;
  margin-top: 40px;
  margin-bottom: 20px;
}
.m-card-company-input-wrapper {
  text-align: left;
  margin-top: 40px;
}
.m-due-date-input-wrapper {
  text-align: left;
}
.m-card-input input {
  max-width: 75px;
  height: 47px;
  border-radius: 2px;
  background-color: #ffffff;
  border: 1px solid #b3d1e0;
  -webkit-appearance: none;
}

.m-alert-encryption-wrapper {
  font-size: 12px;
}
.m-alert-encryption-wrapper span {
  vertical-align: sub;
}
.m-service-agreement-wrapper {
  margin-top: 30px;
  border-top: solid 1px #dee2e5;
  font-size: 12px;
}

.m-button-wrapper {
  margin-top: 50px;
}

/* iPhone 5,5s,SE */
@media only screen and (min-device-width : 320px) and (max-device-width : 568px) {
  .m-card-wrapper {
  padding: 10px;
}
}
</style>



// WEBPACK FOOTER //
// src/components/apply/Card.vue